import { Helmet } from "react-helmet";

const SITE_URL = "https://chatjacai.com";

export default function Seo({
  title,
  description,
  path = "/",
  image,
  imageAlt = "JACAi - Just A Chill AI",
  keywords = [],
  category,
  structuredData,
}) {
  const canonical = `${SITE_URL}${path}`;
  const socialImage = image || `${SITE_URL}/jacai-selection-logo.png`;

  return (
    <Helmet>
      <html lang="ro" />
      <title>{title}</title>
      <meta name="application-name" content="JACAi" />
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      <meta name="author" content="JACAi" />
      <meta name="creator" content="JACAi" />
      <meta name="publisher" content="JACAi" />
      {category && <meta name="category" content={category} />}
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      <meta
        name="googlebot"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      <link rel="canonical" href={canonical} />
      <link rel="manifest" href="/manifest.json" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="JACAi" />
      <meta property="og:locale" content="ro_RO" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
}
